module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto-detail"
  }, [_c('el-form', {
    staticClass: "auto-detail-table",
    attrs: {
      "label-position": "left",
      "inline": ""
    }
  }, _vm._l((_vm.getLayout(_vm.layout).layout), function(key) {
    return (_vm.prop(key).$value(_vm.data)) ? _c('el-form-item', {
      key: key,
      attrs: {
        "label": _vm.prop(key).label
      }
    }, [_c('span', {
      class: _vm.prop(key).$innerClasses(_vm.data)
    }, [_vm._v(_vm._s(_vm.prop(key).$value(_vm.data)))])]) : _vm._e()
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a028c6f","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/auto/AutoDetail.vue
// module id = 286
// module chunks = 0